/*
 * 譲渡・相続の顧客検索（譲渡人・譲受人）
 * 名前または会員IDで検索可能
 */
export default class CustomerSearch {
  constructor() {
    this.$searches = document.querySelectorAll('.search-customer');
  }

  attachEvent() {
    const input = document.querySelector('.search-customer__input');
    if (!input) return;

    input.disabled = true;
    $('.col-form-label.links a').on('click', function(event) {
      event.preventDefault();
      return false;
    });

    const data = document.querySelector('#assignment_search')?.dataset;
    if (!data?.url || !data?.slug) {
      input.disabled = false;
      return;
    }

    const url = `${data.url}?project_slug=${data.slug}`;
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;

      this.releaseSearchInput(input);

      if (xhr.status !== 200) {
        return;
      }

      let customers;
      try {
        customers = JSON.parse(xhr.responseText);
      } catch {
        return;
      }

      if (!Array.isArray(customers)) {
        return;
      }

      this.search(customers);
    };
    xhr.onerror = () => {
      this.releaseSearchInput(input);
    };
    xhr.send();
  }

  releaseSearchInput(input) {
    if (input) input.disabled = false;
    $('.col-form-label.links a').off('click');
  }

  /**
   * 検索文字列が名前または会員ID(display_id)に含まれるか
   */
  static matchesQuery(customer, query) {
    if (!customer || !query) return false;
    const normalizedQuery = query.replace(/\s+/g, '');
    const namePart = (customer.name || '').toString().replace(/\s+/g, '');
    const idPart = (customer.display_id != null ? String(customer.display_id) : '');
    return namePart.includes(normalizedQuery) || idPart.includes(normalizedQuery);
  }

  search(customers) {
    const self = this;
    document.addEventListener('keyup', function onKeyup(e) {
      const input = e.target;
      if (!input.classList.contains('search-customer__input')) return;

      const searchCustomer = input.closest('.search-customer');
      const isAssignor = input.classList.contains('search-assignor');
      const value = input.value.replace(/\s+/g, '');
      const suggestBox = searchCustomer?.querySelector('.search-customer__suggest');
      if (!suggestBox) return;

      suggestBox.innerHTML = '';
      if (value.length < 2) return;

      const searchedCustomers = customers.filter(customer => {
        const matches = self.constructor.matchesQuery(customer, value);
        const assignorOk = isAssignor ? (customer.claimed_unit || 0) > 0 : true;
        return matches && assignorOk;
      });

      if (searchedCustomers.length > 0) {
        suggestBox.appendChild(self.buildSuggestList(searchedCustomers, (item) => self.selectCustomer(item)));
      }
    });
  }

  buildSuggestList(customers, onSelect) {
    const list = document.createElement('ul');
    list.className = 'list-group my-1';
    customers.forEach(customer => {
      const item = document.createElement('li');
      item.className = 'list-group-item list-group-item-action';
      item.dataset.id = customer.id;
      item.dataset.display_id = customer.display_id != null ? String(customer.display_id) : '';
      item.dataset.name = customer.name != null ? String(customer.name) : '';
      item.dataset.address = customer.address != null ? String(customer.address) : '';
      item.dataset.claimed_unit = customer.claimed_unit != null ? String(customer.claimed_unit) : '0';
      item.textContent = customer.name ? `${customer.name}（${customer.display_id}）` : String(customer.display_id ?? '');
      item.addEventListener('click', () => onSelect(item));
      list.appendChild(item);
    });
    return list;
  }

  selectCustomer(clickedItem) {
    const suggestList = clickedItem?.parentElement;
    const customer = clickedItem?.dataset ?? {};
    const searchCustomer = clickedItem?.closest('.search-customer');
    const result = searchCustomer?.querySelector('.search-customer__result');
    if (!result) return;

    const idEl = result.querySelector('.customer-id');
    const displayIdEl = result.querySelector('.customer-display_id');
    const nameEl = result.querySelector('.customer-name');
    const addressEl = result.querySelector('.customer-address');
    const claimedUnitEl = result.querySelector('td.customer-claimed_unit');

    if (idEl) idEl.value = customer.id;
    if (displayIdEl) displayIdEl.innerText = customer.display_id;
    if (nameEl) nameEl.innerText = customer.name;
    if (addressEl) addressEl.innerText = customer.address;
    if (claimedUnitEl) claimedUnitEl.innerText = `${customer.claimed_unit} 口`;

    suggestList?.remove();
    result.classList.remove('d-none');
  }
}
